var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('router-view'):_c('splash')
}
var staticRenderFns = []

export { render, staticRenderFns }